import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Pluralize from 'react-pluralize';
import InfoIcon from '@material-ui/icons/Info';
import _ from 'lodash';
import InfoDropdownPopover from '../../../InfoDropdownPopover';
import currencySymbol from '../../../../helpers/currencySymbol';

const FlightFareBreakdown = ({ flightItinerary }) => {
  if (
    !flightItinerary ||
    !flightItinerary.fareBreakdowns ||
    !flightItinerary.fareBreakdowns.length ||
    !_.find(flightItinerary.fareBreakdowns, (f) => !!f.passengerTotal) ||
    ((flightItinerary.cost || {}).price || 0) === 0
  ) {
    return <></>;
  }
  const formatNumber = (amount, currencyCode) => (
    <NumberFormat
      value={amount || 0}
      displayType="text"
      thousandSeparator
      prefix={currencySymbol(currencyCode)}
      fixedDecimalScale="true"
      decimalScale="2"
    />
  );

  return (
    <InfoDropdownPopover dropdownTextPlaceholder="Price breakdown" fontSize="text-sm" alignClass="">
      <div className="px-5 py-4 text-left font-normal text-xs">
        <div className="font-bold text-sm">Price Breakdown:</div>
        {flightItinerary.fareBreakdowns.map((f) => (
          <div className="grid grid-cols-3" key={f.passengerType}>
            <hr className="my-2 col-span-3" />
            <div className="font-bold col-span-3">
              <Pluralize singular={f.passengerType} count={f.passengerNumber} />
            </div>

            <div className="col-span-2">Base price</div>
            <div className="text-right">
              {formatNumber(f.passengerTotal.baseFare, flightItinerary.cost.currencyCode)}
            </div>

            <div className="col-span-2">Total taxes, fees and charges</div>
            <div className="text-right">
              {formatNumber(f.passengerTotal.taxesAndFees, flightItinerary.cost.currencyCode)}
            </div>

            <div className="col-span-2">Total per {f.passengerType}</div>
            <div className="text-right">
              {formatNumber(f.passengerTotal.totalPerTraveler, flightItinerary.cost.currencyCode)}
            </div>

            <div className="col-span-2 font-bold">
              Total for <Pluralize singular={f.passengerType} count={f.passengerNumber} />
            </div>
            <div className="text-right font-bold">
              {formatNumber(f.passengerTotal.total, flightItinerary.cost.currencyCode)}
            </div>
            {f.passengerTotal.isAdultFareUsed ? (
              <div className="col-span-4 flex gap-1 text-xs text-gray-600">
                <InfoIcon style={{ fontSize: '1rem', marginTop: 2 }} className="text-theme" />
                {f.passengerType} fare not applicable - adult fare used - verify restrictions
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
      <div className="bg-body-0 px-5 pt-2 pb-4 border-t-2 text-sm">
        <div className="font-bold grid grid-cols-3">
          <div className="col-span-2">Total</div>
          <div className="text-right">
            <span>
              {formatNumber(flightItinerary.cost.price, flightItinerary.cost.currencyCode)}
            </span>
          </div>
        </div>
      </div>
    </InfoDropdownPopover>
  );
};

FlightFareBreakdown.propTypes = {
  flightItinerary: PropTypes.shape().isRequired,
};

export default FlightFareBreakdown;
